<template>
  <div @mouseenter="mouseenter" @mouseleave="mouseleave">
    <slot v-bind="{ selectSlide }"></slot>
  </div>
</template>
<script>
import Swiper from 'swiper/bundle'
import $ from 'cash-dom'

export default {
  data () {
    return {
      swiper: null,
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.swiper = new Swiper(this.$el, {
        slidesPerView: 'auto',
        hashNavigation: false,
        spaceBetween: 0,
        speed: 750,
        loop: false,
        autoplay: {
          delay: 7000
        },
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev',
          hiddenClass: 'd-none',
          disabledClass: 'd-none',
        }
      })
    })
  },
  methods: {
    mouseenter () {
      if (this.swiper) {
        this.swiper.autoplay.stop()
      }
    },
    mouseleave () {
      if (this.swiper) {
        this.swiper.autoplay.start()
      }
    },
    selectSlide (event) {
      var index = $(event.target).index()

      if (this.swiper.activeIndex === index + 1) {
        this.swiper.slidePrev()
      } else if (this.swiper.activeIndex === index - 1) {
        this.swiper.slideNext()
      }
    }
  }
}
</script>